import type { ApprovalRequest } from './records/ApprovalRequest';

const STOP_ITERATION = 'stopIteration';
const START_ITERATION = 'startIteration';
const SAVE_AND_START_ITERATION = 'saveAndStartNewIteration';

type ExperimentApprovalAction = 'stopped' | 'started' | undefined;

/**
 * Returns 'stopped' or 'started' when the approval targets an experiment
 * with a matching instruction kind, otherwise undefined.
 */
export function getExperimentApprovalAction(approval: ApprovalRequest): ExperimentApprovalAction {
  if (approval.getResourceKindName() !== 'experiment') {
    return undefined;
  }
  // Experiment instruction kinds (stopIteration, startIteration, saveAndStartNewIteration)
  // are not part of WorkflowSemanticInstruction but appear at runtime in experiment approvals.
  // String() avoids a type assertion while safely comparing the kind values.
  if (approval.instructions.some((ins) => String(ins.kind) === STOP_ITERATION)) {
    return 'stopped';
  }
  if (
    approval.instructions.some(
      (ins) => String(ins.kind) === START_ITERATION || String(ins.kind) === SAVE_AND_START_ITERATION,
    )
  ) {
    return 'started';
  }
  return undefined;
}
